// Generated from SVG to React Component
import React, { SVGProps } from "react";

export const SidebarMd = ({ color = "black", ...props }: SVGProps<SVGSVGElement>) => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <rect x="2.14844" y="4.50275" width="15.7047" height="10.9939" rx="1.66667" stroke={color} strokeWidth="1.5" />
        <path d="M8.33301 15.0395V4.96173" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
        <path d="M6.07047 7.25098H4.5" stroke={color} strokeWidth="0.75" strokeLinecap="round" />
        <path d="M4.5 9.08398H6.07047" stroke={color} strokeWidth="0.75" strokeLinecap="round" />
        <path d="M6.07047 10.916H4.5" stroke={color} strokeWidth="0.75" strokeLinecap="round" />
    </svg>

);
